const fragment = `
  id
  name
`;

export const listSpecificationsQuery = `
  query ListSpecifications(
    $filter: SpecificationFilterInput
  ) {
    items: listSpecifications(filter: $filter) {
      ${fragment}
    }
  }
`;

export const createSpecificationQuery = `
  mutation CreateSpecification(
    $input: CreateSpecificationInput!
  ) {
    item: createSpecification(input: $input) {
      ${fragment}
    }
  }
`;

export const updateSpecificationQuery = `
  mutation UpdateSpecification(
    $input: UpdateSpecificationInput!
  ) {
    item: updateSpecification(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteSpecificationQuery = `
  mutation DeleteSpecification(
    $id: Int!
  ) {
    item: deleteSpecification(id: $id) {
      ${fragment}
    }
  }
`;
